import type {Campaign, CampaignPaidGigBriefItem} from '@/types/campaign';

export const AI_BRIEF_FILTERED_TITLES = [
  'Deliverables',
  'Campaign hashtag',
  'Caption guidelines',
  'Timeline overview',
  'Ideal creator',
] as const;

export function filterBriefItems(
  items: CampaignPaidGigBriefItem[],
  titlesToExclude: readonly string[]
): CampaignPaidGigBriefItem[] {
  const excluded = new Set(titlesToExclude.map((t) => t.toLowerCase()));
  return items.filter((item) => !excluded.has(item.title.toLowerCase()));
}

export function getBriefItemByTitle(
  items: CampaignPaidGigBriefItem[],
  title: string
): CampaignPaidGigBriefItem | undefined {
  const lower = title.toLowerCase();
  return items.find((item) => item.title.toLowerCase() === lower);
}

export type SectionsToHide = {
  followersCount: boolean;
  postingInstructions: boolean;
  campaignHashtag: boolean;
  urlToPromote: boolean;
};

export function computeSectionsToHide(
  campaign: Pick<Campaign, 'network'>
): SectionsToHide {
  const hasNetwork = Boolean(campaign.network);
  return {
    followersCount: !hasNetwork,
    postingInstructions: !hasNetwork,
    campaignHashtag: !hasNetwork,
    urlToPromote: !hasNetwork,
  };
}
